import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SeismicLineTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-seismic-line-type',
  templateUrl: './seismic-line-type.component.html',
  styleUrls: ['./seismic-line-type.component.scss'],
})
export class SeismicLineTypeComponent implements OnChanges {
  linenumberForm: FormGroup;
  linenumberFormArray: FormGroup;
  control = new FormControl();
  @Input() linenumbers: SeismicLineTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() linenumber = new EventEmitter<SeismicLineTypeDto[]>();
  @Output() deleteLineNumberEvent = new EventEmitter<any>();

  selectedLineNumber: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createLineNumberForm();
  }

  createLineNumberForm() {
    this.linenumberForm = this.fb.group({
      LineNumberName: ['', Validators.required],
      LineNumber: [''],
      // SubscriberEmail: [''],
      id: null,
    });
    this.linenumberFormArray = this.fb.group({
      LineNumbers: this.fb.array([]),
    });
    this.setLineNumber();
  }

  // method to display linenumbers
  setLineNumber() {
    const control = this.linenumberFormArray.controls.LineNumbers as FormArray;
    this.linenumbers.forEach((e) => {
      control.push(
        this.fb.group({
          LineNumberName: e.LineNumberName,
          LineNumber: e.LineNumber,
          // SubscriberEmail: e.SubscriberEmail,
          id: e.id,
        })
      );
    });
  }

  // method to add LineNumber
  addLineNumber(value: SeismicLineTypeDto) {
    const control = this.linenumberFormArray.controls.LineNumbers as FormArray;
    control.insert(
      0,
      this.fb.group({
        LineNumberName: value.LineNumberName,
        LineNumber: value.LineNumber,
        // SubscriberEmail: value.SubscriberEmail,
        id: null,
      })
    );
  }

  selectLineNumber(value) {}

  // method to delete linenumber from arrary list
  deleteLineNumber(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.linenumberFormArray.controls
          .LineNumbers as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.linenumbers.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.linenumbers[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SeismicLineTypeDto) {
    if (this.linenumberForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.linenumberFormArray
        .get('LineNumbers')
        ['controls'][this.selectedIndex].patchValue({
          LineNumberName: formValue.LineNumberName,
        });
    } else {
      this.addLineNumber(formValue);
    }
    this.selectedIndex = null;
    this.linenumberForm.reset();
  }

  onEdit(index, value: SeismicLineTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.linenumberForm.patchValue({
      LineNumberName: value.LineNumberName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.linenumberForm.reset();
  }

  onSubmit(formValue: SeismicLineTypeDto[]) {
    this.linenumber.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteLineNumberEvent.emit(this.filteredDelete);
    }
  }
}
